import Icon from 'veui/components/Icon'

Icon.register({
  clip: {
    paths: [
      {
        d: 'M269.1 725.7a224.24 224.24 0 01-159.61-66.12l-1.43-1.43c-42.61-42.61-65.83-99.63-65.4-160.56a227.35 227.35 0 0166.83-160.1L235 212c56.77-56.77 149.14-56.77 205.91 0s56.77 149.13 0 205.9L291.73 567.07a32 32 0 11-45.25-45.26l149.17-149.17a81.6 81.6 0 00-115.39-115.4L154.75 382.75a163.69 163.69 0 00-48.09 115.3c-.31 43.66 16.26 84.45 46.65 114.85l1.43 1.43c63.06 63 165.66 63 228.72 0l230.22-230.22a162.76 162.76 0 00-209.35-247.76 32 32 0 01-37.14-52.12 226.75 226.75 0 01291.74 345.14L428.72 659.58A224.25 224.25 0 01269.1 725.7z'
      }
    ],
    width: '768',
    height: '768'
  }
})
